import React, { Component } from 'react';
import {getPrimaryContactName} from "../../utils/LinkedAccountHelpers";

import {connect} from 'react-redux';
import LinkAccountCard from "./LinkAccountCard";
import {getUserPermission, selectLinkedAccountsLoading} from "../../selectors";
import {getLinkedAccountInfo} from "../../actions/getLinkedAccountInfo";



const PANEL = {
    NONE: 0,
    INVOICES: 1,
    MANAGE_PLANS: 2,
    PAYMENT: 3,
    AUTOPAY: 4,
    PAPERLESS: 5,
    ORDERS: 6,
    PAYMENTS: 7,
    MANAGE_PAYMENTS: 8,
    ADD_EDIT_PAYMENT_METHODS: 9,
    ONE_TIME_PAYMENT: 10,
    LINK: 11
}
class LinkedAccount extends Component {

    render() {

        const {
            myAmounts,
            linkedAccounts,
            handleManageClick,
            primaryAccountInfo,
            canPayNow,

        } = this.props;



        return (
            <div className="container-customer-services">
                <div className="container">

                    <div className="container-customer mt-4">
                        <div className="row">
                            <div className="cp-col col-sm-7">
                                <h3>
                                    <span className="font-weight-light">Welcome back <strong>{getPrimaryContactName(primaryAccountInfo)}!</strong> </span>{' '}
                                </h3>
                                <p>

                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="row">

                        <div className="cp-col col-12 col-lg-6 d-flex">
                            <LinkAccountCard
                                accountInformation={primaryAccountInfo}
                                handleManageClick={this.props.handleManageClick}
                                accountId={primaryAccountInfo.id}
                                accountType={primaryAccountInfo.accountType.name}
                                primaryAcct={true}
                                setTogglePanel={(func) => this.childTogglePanel = func}
                            />
                        </div>
                        {linkedAccounts.linkedAccountList
                            .filter(account => account.registeredDatetime) // Filter accounts with registeredDatetime
                            .map((account, index) => (
                                <div className="cp-col col-12 col-lg-6 d-flex" key={index}>
                                    <LinkAccountCard
                                        accountInformation={account}
                                        handleManageClick={this.props.handleManageClick}
                                        accountId={account.accountInfo.accountId}
                                        accountType={account.accountInfo.accountType}
                                        primaryAcct={false}
                                        setTogglePanel={(func) => this.childTogglePanel = func}
                                    />
                                </div>
                            ))}

                    </div>

                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const canPayNow = getUserPermission(state, "BILLING", "BILLING_PAY_NOW"),
        canViewPayments = getUserPermission(state, "BILLING", "BILLING_PAYMENTS_VIEW"),
        canViewInvoices = getUserPermission(state, "BILLING", "BILLING_INVOICES_VIEW"),
        canManagePaymentMethods = getUserPermission(state, "API", "API_MANAGE_PAYMENT_METHODS"),
        loading =selectLinkedAccountsLoading(state);

    return {
        canPayNow,
        canViewPayments,
        canViewInvoices,
        canManagePaymentMethods,
        loading
    }
}

const mapDispatchToProps = {

};

export default connect(mapStateToProps, mapDispatchToProps)(LinkedAccount);